"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _string_utility = require("../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _card_component = require("./global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _sanitize_utility = require("../../../packages/common-utilities/src/sanitize_utility");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _fund_document_list = require("./fund_document_list");

var _fund_document_list2 = _interopRequireDefault(_fund_document_list);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _collection_utility = require("../../../packages/common-utilities/src/collection_utility");

var _esg_approach_card = require("./esg_approach_card");

var _esg_approach_card2 = _interopRequireDefault(_esg_approach_card);

var _fund_utility = require("../../../packages/common-utilities/src/fund_utility");

var _ramda = require("ramda");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundESGInformation = function (_React$PureComponent) {
    _inherits(FundESGInformation, _React$PureComponent);

    function FundESGInformation() {
        _classCallCheck(this, FundESGInformation);

        return _possibleConstructorReturn(this, (FundESGInformation.__proto__ || Object.getPrototypeOf(FundESGInformation)).apply(this, arguments));
    }

    _createClass(FundESGInformation, [{
        key: "renderESGIntroductionCard",
        value: function renderESGIntroductionCard() {
            var intl = this.props.intl;


            var defaultCardContent = intl.formatMessage({ id: "pdp-esg-introduction-card-content", defaultMessage: "" });
            var cardContent = intl.formatMessage({ id: "pdp-esg-introduction-card-content-" + this.props.role, defaultMessage: defaultCardContent });

            return _react2.default.createElement(
                _card_component2.default,
                { headerTitle: _string_utility2.default.renderFormattedLabel("ESG Introduction", "pdp-esg-introduction-card-label"),
                    headerTitleId: "esg-introduction-card",
                    headerTitleLabel: "esg-introduction-card",
                    headerLabel: "",
                    breakpoint: this.props.breakpoint },
                _react2.default.createElement(
                    "div",
                    { className: "body1", "data-testid": "esg-introduction-card-content", id: "esg-introduction-card-content" },
                    _react2.default.createElement(
                        "div",
                        { "data-testid": "esg-introduction-card-content-text" },
                        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(cardContent) } })
                    )
                )
            );
        }
    }, {
        key: "addSFDRDocuments",
        value: function addSFDRDocuments(filteredDocs) {
            var _this2 = this;

            if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_SFDR_DOCUMENTS')) {
                var languages = _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_ADDITIONAL_LANGUAGES_SFDR_DOCUMENTS') ? [this.props.language.toUpperCase(), "EN"] : [this.props.language.toUpperCase()];
                var docType = this.props.fund.stringValueWrapper.fundIndicatorValue === "Article 8" ? "Environmental / Social Characteristics Disclosure" : "Sustainable Objective Disclosure";
                var docTitleBase = this.props.fund.stringValueWrapper.fundIndicatorValue === "Article 8" ? "fx-esg-tab-document-environmental-social-characteristics-title" : "fx-esg-tab-document-sustainable-objective-disclosure-title";

                languages.forEach(function (lang) {
                    var doc = {
                        title: _string_utility2.default.renderFormattedLabel(docType, "" + docTitleBase + (lang === "EN" ? "-EN" : "")),
                        isProtected: false,
                        isGlassDoor: false,
                        docURL: "https://www.pl.jpmam.avanterra.com/ESG/WD/" + _this2.props.fund.legalEntityIdentifier + "_" + lang + ".pdf"
                    };
                    filteredDocs.push(doc);
                });
            }
            return filteredDocs;
        }
    }, {
        key: "renderESGDocumentsCard",
        value: function renderESGDocumentsCard() {
            var _this3 = this;

            var _props = this.props,
                breakpoint = _props.breakpoint,
                content = _props.content,
                cusip = _props.cusip,
                isAEM = _props.isAEM;


            var filteredDocs = (0, _fund_utility.getDocumentsFromContentByDocType)(content, cusip, isAEM, "ESG Information");
            filteredDocs = (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
                return x === _this3.props.language || (0, _ramda.isNil)(x);
            }, 'language'), filteredDocs);
            var sfdrDocs = this.addSFDRDocuments([]);
            var showSubHeader = _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_ESG_DOC_SUB_HEADER');

            var getFundDocumentList = function getFundDocumentList(_filteredDocs) {
                return _react2.default.createElement(_fund_document_list2.default, { documents: _filteredDocs,
                    userLoggedIn: _this3.props.userLoggedIn,
                    headerTitleId: "esg-documents-card",
                    role: _this3.props.role,
                    basePath: _this3.props.basePath,
                    window: _this3.props.window,
                    defaultStyle: "tag",
                    textColorClass: "font-teal",
                    showDownloadIcon: false,
                    isAEM: isAEM,
                    noOfColumns: 1,
                    isDocumentTabCard: false
                });
            };
            return !(0, _functional_utility.isNilOrEmpty)([].concat(_toConsumableArray(filteredDocs), _toConsumableArray(sfdrDocs))) && _react2.default.createElement(
                _card_component2.default,
                {
                    headerTitle: _string_utility2.default.renderFormattedLabel("ESG Documents", "pdp-esg-documents-card-label"),
                    headerTitleId: "esg-documents-card",
                    headerTitleLabel: "esg-documents-card",
                    headerLabel: "",
                    breakpoint: breakpoint },
                _react2.default.createElement(
                    "div",
                    { "data-testid": "esg-documents-card-content", id: "esg-documents-card-content" },
                    getFundDocumentList(filteredDocs),
                    showSubHeader && _react2.default.createElement(
                        "div",
                        { "data-testid": "esg-documents-card-sub-header",
                            className: 'text-left tag white-space-default margin-top-10' },
                        _string_utility2.default.renderFormattedLabel("Sustainability-related disclosures", "pdp-esg-documents-card-sub-header")
                    ),
                    getFundDocumentList(sfdrDocs)
                )
            );
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            return !(0, _functional_utility.isNilOrEmpty)(nextProps);
        }
    }, {
        key: "renderESGApproachCard",
        value: function renderESGApproachCard() {
            if (!this.props.fund.esgData.esgIntegrationFlag) {
                return null;
            }
            if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_ESG_INTEGRATED_CARD')) {
                return null;
            }
            return _react2.default.createElement(_esg_approach_card2.default, {
                placementId: "esg-information-esg-approach",
                breakpoint: this.props.breakpoint,
                fund: this.props.fund,
                country: this.props.country,
                language: this.props.language,
                role: this.props.role,
                tooltip: this.props.tooltip
            });
        }
    }, {
        key: "render",
        value: function render() {
            var breakpoint = this.props.breakpoint;

            var mobileClasses = breakpoint < 3 ? "margin-all-0" : "";

            if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, 'ESG_INFORMATION_COLUMN_LAYOUT')) {
                return _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "div",
                        { "data-testid": "esg-approach-card-column",
                            className: "col-xs-12 col-sm-12 " + (breakpoint === 3 ? "col-md-12 col-lg-12 col-xlg-12 margin-left-0" : "col-md-4 col-lg-4 col-xlg-4") + " " + mobileClasses + " print-hide screen-visible print-full-width" },
                        this.renderESGApproachCard()
                    ),
                    _react2.default.createElement(
                        "div",
                        { "data-testid": "esg-document-card-column",
                            className: "col-xs-12 col-sm-12 " + (breakpoint === 3 ? "col-md-12 col-lg-12 col-xlg-12 margin-left-0" : "col-md-4 col-lg-4 col-xlg-4") + " " + mobileClasses + " print-hide screen-visible print-full-width" },
                        !_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_ESG_DOC') && this.renderESGDocumentsCard()
                    )
                );
            }

            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                    "div",
                    { "data-testid": "esg-information-column",
                        className: "col-xs-12 col-sm-12 " + (breakpoint === 3 ? "col-md-12 col-lg-12 col-xlg-12" : "col-md-8 col-lg-8 col-xlg-8") + " " + mobileClasses + " print-full-width" },
                    this.renderESGIntroductionCard(),
                    this.renderESGApproachCard()
                ),
                _react2.default.createElement(
                    "div",
                    { "data-testid": "esg-information-side-column",
                        className: "col-xs-12 col-sm-12 " + (breakpoint === 3 ? "col-md-12 col-lg-12 col-xlg-12 margin-left-0" : "col-md-4 col-lg-4 col-xlg-4") + " " + mobileClasses + " print-hide screen-visible print-full-width" },
                    this.renderESGDocumentsCard()
                )
            );
        }
    }]);

    return FundESGInformation;
}(_react2.default.PureComponent);

exports.default = FundESGInformation;